// === SHOPIFY MARKETS CURRENCY PRICE UPDATER ===
(function() {
  const priceMap = {
    'EUR': { 60: '€60', 100: '€100', 120: '€120', 150: '€150' },
    'GBP': { 60: '£48', 100: '£80', 120: '£96', 150: '£120' },
    'ISK': { 60: 'kr 8,400', 100: 'kr 14,000', 120: 'kr 16,800', 150: 'kr 21,000' },
    'CAD': { 60: 'C$85', 100: 'C$140', 120: 'C$170', 150: 'C$210' },
    'CHF': { 60: 'CHF 55', 100: 'CHF 90', 120: 'CHF 110', 150: 'CHF 135' },
    'DKK': { 60: 'kr 425', 100: 'kr 710', 120: 'kr 850', 150: 'kr 1,065' },
    'SEK': { 60: 'kr 635', 100: 'kr 1,060', 120: 'kr 1,270', 150: 'kr 1,590' },
    'NOK': { 60: 'kr 635', 100: 'kr 1,060', 120: 'kr 1,270', 150: 'kr 1,590' },
    'HUF': { 60: 'Ft 23,500', 100: 'Ft 39,200', 120: 'Ft 47,000', 150: 'Ft 58,800' },
    'CZK': { 60: 'Kč 1,450', 100: 'Kč 2,420', 120: 'Kč 2,900', 150: 'Kč 3,630' },
    'PLN': { 60: 'zł 255', 100: 'zł 425', 120: 'zł 510', 150: 'zł 640' }
  };

  let isUpdating = false;

  function getCurrency() {
    if (window.Shopify?.currency?.active) return window.Shopify.currency.active;

    const input = document.querySelector('input[name="country_code"]');
    if (!input?.value) return 'EUR';

    const map = { 
      'GB': 'GBP', 
      'IS': 'ISK', 
      'CA': 'CAD', 
      'CH': 'CHF', 
      'DK': 'DKK', 
      'SE': 'SEK', 
      'NO': 'NOK', 
      'HU': 'HUF',
      'CZ': 'CZK',
      'PL': 'PLN'
    };
    return map[input.value] || 'EUR';
  }

  function replacePrices(text, prices) {
    return text
      .replace(/€\s?150|150\s?€/gi, prices[150])
      .replace(/€\s?120|120\s?€/gi, prices[120])
      .replace(/€\s?100|100\s?€/gi, prices[100])
      .replace(/€\s?60|60\s?€/gi, prices[60]);
  }

  function updatePrices() {
    if (isUpdating) return;
    isUpdating = true;

    const currency = getCurrency();
    const prices = priceMap[currency] || priceMap['EUR'];

    // Announcement bar - VSI <p> elementi
    document.querySelectorAll('.announcement-bar__static-list p, announcement-bar p').forEach(p => {
      const newText = replacePrices(p.textContent, prices);
      if (p.textContent !== newText) {
        p.textContent = newText;
      }
    });

    // Offer blocks
    document.querySelectorAll('.product-info__block-item[data-block-type="offer"] .prose li').forEach(li => {
      const newHtml = replacePrices(li.innerHTML, prices);
      if (li.innerHTML !== newHtml) {
        li.innerHTML = newHtml;
      }
    });

    isUpdating = false;
  }

  function debounce(fn, delay) {
    let timeout;
    return function() {
      clearTimeout(timeout);
      timeout = setTimeout(fn, delay);
    };
  }

  const debouncedUpdate = debounce(updatePrices, 100);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updatePrices);
  } else {
    updatePrices();
  }

  document.addEventListener('click', e => {
    if (e.target.closest('[data-disclosure-option], .localization-selector')) {
      setTimeout(updatePrices, 200);
    }
  });

  document.addEventListener('currency.change', updatePrices);

  const observer = new MutationObserver(debouncedUpdate);
  observer.observe(document.body, { childList: true, subtree: true });

})();